<template>
    <div id="versions-index-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Versions</h1>

                <DataTable class="versions-data-table"
                        :dataUrl="dataUrl"
                        :displayId="false"
                        :key="tableRefreshKey"
                        :dataFormatter="formatData"
                        @actionTriggered="actionTriggered">

                    <template v-slot:empty>
                        No records found
                    </template>
                </DataTable>
            </section>
        </div>
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'
const endpoint = process.env.VUE_APP_API_BASE + '/versions'

export default {
    name: 'VersionsIndex',
    components: {
        DataTable
    },
    data: function() {
        return {
            dataUrl: endpoint,
            tableRefreshKey: null
        }
    },
    methods: {
        formatData(data) {
            const newData = []
            for (let obj of data) {
                const newObj = {}
                for (let key in obj) {
                    const ignore = ['__v', 'formattedVersion']
                    if (ignore.includes(key)) {
                        continue
                    }
                    else if (key.includes('At')) {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'date'
                        }
                    }
                    else {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'text'
                        }
                    }
                }
                /*
                const actions = {
                    'edit': `<i class="edit-user-action" title="Edit">Edit</i>`,
                    'delete': `<i class="delete-user-action" title="Delete">Delete</i>`
                }
                newObj['actions'] = {
                    'label': '',
                    'value': actions,
                    'display_type': 'actions'
                }
                */

                //const newObjOrdered = Object.assign({'image': ''}, newObj)
                newData.push(newObj)
            }
            return newData
        },
        actionTriggered(actionKey, identifier) {
            if (!identifier) {
                alert('Error occurred #89')
            }
            else if (actionKey == 'edit') {
                alert('edit')
            }
            else if (actionKey == 'delete') {
                alert('delete')
            }
        },
    }
}
</script>

<style lang="scss" scoped>
</style>
